import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { GenericVideo, PlayIcon } from '../svg';
import { getScreenSize } from '../../../../../../../FlyfishComponents/flyfishutils/utils';
import Button from '../../../../../../../FlyfishComponents/Button';
import { getImg } from '../../../../../../../../Utils/getImg';

const ICDiv = styled.div<{ type: string }>`
	cursor: pointer;
	height: ${(props) => (props.type === 'video' ? '275px' : '249px')};
	max-width: 234px;
	max-height: 248px;
	&.displayCount-3 {
		width: ${(props) =>
			props.screenSize < 800 && props.screenSize > 425 ? '100%' : '33%'};
	}
	&.displayCount-2 {
		max-width: 494px;
		width: ${(props) =>
			props.screenSize < 800 && props.screenSize > 425 ? '100%' : '50%'};
	}
	&.displayCount-1 {
		height: unset;
		width: 100%;
		display: flex;
		max-width: unset;
		border: unset;
		border-radius: unset;
		& > .image-video {
			height: unset;
			border-bottom: unset;
			& > img {
				width: 100%;
				max-height: ${(props) => (props.type === 'video' ? '159px' : '164px')};
				border-radius: 11px;
				object-fit: cover;
				min-width: 262px;
				height: 100%;
				border: 1px solid #7070702e;
			}
			& > svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
	border: 1px solid #b9b9b982;
	border-radius: 11px;
	& > .image-video {
		height: 60%;
		position: relative;
		border-bottom: 1px solid #b9b9b982;
		& > img {
			width: 100%;
			max-height: ${(props) => (props.type === 'video' ? '159px' : '207px')};
			border-top-right-radius: 11px;
			border-top-left-radius: 11px;
			object-fit: cover;
			height: 100%;
		}
		& > svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
`;

const ICDescDiv = styled.div`
	padding: 15px 23px;
	padding-bottom: 20px;
	height: 30%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	&.displayCount-1 {
		height: unset;
		padding: unset;
		padding-left: 25px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-height: 164px;
	}
	& > .tooltip-wrapper {
		text-align: left;
	}
	& .ff-chatbot-body1 {
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		text-align: start;
		color: #000;
		font-feature-settings: 'liga' off, 'clig' off;
		font-family: var(--fontFamily);
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 18px; /* 150% */
	}
	& .description {
		overflow: hidden;
		margin: 10px 0 !important;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		color: #000;
		font-feature-settings: 'liga' off, 'clig' off;
		font-family: var(--fontFamily);
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 18px; /* 150% */
	}
	& > .read-more {
		color: #3e8bd1;
		font-feature-settings: 'liga' off, 'clig' off;
		font-family: var(--fontFamily);
		font-size: 9.881px;
		font-style: normal;
		font-weight: 500;
		line-height: 11.857px; /* 120% */
		text-align: left;
		& > span {
			margin-right: 4px;
		}
	}

	& > .channel-duration {
		display: flex;
		align-items: center;
		gap: 15px;
		& > .channel {
			display: flex;
		}
	}
`;
type Props = {
	URL: string;
	heading: string;
	desc?: string;
	readMoreUrl?: string;
	type?: string;
	displayCardCount?: number;
	currentClick?: Function;
};

const ImageCards = ({
	URL,
	heading,
	desc,
	readMoreUrl,
	type,
	displayCardCount,
	currentClick,
}: Props) => {
	const [videoChannel, setVideoChannel] = useState('');

	useEffect(() => {
		if (readMoreUrl.indexOf('youtube.com') > -1) {
			setVideoChannel('youtube');
		} else if (readMoreUrl.indexOf('vimeo.com') > -1) {
			setVideoChannel('vimeo');
		} else {
			setVideoChannel('video');
		}
	}, []);
	return (
		<ICDiv
			onClick={() => {
				window.open(readMoreUrl);
				currentClick();
			}}
			type={type}
			screenSize={getScreenSize()}
			className={`displayCount-${displayCardCount} parent ff-card-carousel`}
		>
			<div className='image-video'>
				<img src={URL} alt='' />
				{type === 'video' ? <PlayIcon /> : null}
			</div>
			<ICDescDiv className={`displayCount-${displayCardCount} child`}>
				<div>
					<Tooltip title={heading}>
						<p className='ff-chatbot-body1'>{heading}</p>
					</Tooltip>
					<Tooltip title={desc}>
						<p className='description'>{desc}</p>
					</Tooltip>
				</div>
				{type === 'video' ? (
					<div className='channel-duration'>
						<div className='channel'>
							{videoChannel === 'youtube' ? (
								<img src={getImg('youtube.png')} alt='' />
							) : (
								<GenericVideo />
							)}
						</div>
						<div className='ff-chatbot-caption'>1 min 27 sec</div>
						<div className='ff-chatbot-caption'>Jul 26, 2023</div>
					</div>
				) : (
					<div className='read-more' onClick={() => window.open(readMoreUrl)}>
						<span>Read More</span>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='8'
							height='8'
							viewBox='0 0 8 8'
							fill='none'
						>
							<path
								d='M0.687082 4.27776H6.61565'
								stroke='#3E8BD1'
								stroke-width='0.988095'
								stroke-linecap='round'
								stroke-linejoin='round'
							/>
							<path
								d='M3.65137 1.31348L6.61565 4.27776L3.65137 7.24205'
								stroke='#3E8BD1'
								stroke-width='0.988095'
								stroke-linecap='round'
								stroke-linejoin='round'
							/>
						</svg>
					</div>
				)}
			</ICDescDiv>
		</ICDiv>
	);
};

export default ImageCards;
